export enum ListItemsIds {
    BeInNetherlandsOrUK = 'beInNetherlandsOrUK',
    HaveMewsPayments = 'haveMewsPayments',
    HaveCardPayments = 'haveCardPayments',
}

export enum CapitalLaunchEnterpriseCountryCodes {
    NL = 'NL',
    GB = 'GB',
    ES = 'ES',
    DE = 'DE',
    BE = 'BE',
    US = 'US',
    PL = 'PL',
    IE = 'IE',
}
